import { Col, Row, Typography, message } from "antd";
import numeral from "numeral";
import { connect } from "react-redux";
import React, { useEffect, useState, useMemo } from "react";
import { withRouter } from "react-router";
import { axios, _, URL_API } from "../../../../utils";
import { getSummaryTotalPayment } from "./logic";
import { Creators } from "../ducks/operation-form";
const RpRedeem = (props) => {
  const { myRp, deliveryDiscount, delivery, order, discountRedeem } = props;
  const [inputRp, setInputRp] = useState("0");
  const [isLoading, setIsLoading] = useState(false);
  const [rpConvertRate, setRpConvertRate] = useState(27);
  const formatToString = (num) => {
    return numeral(num).format("0,0");
  };
  const formatToNumber = (str) => {
    return _.toNumber(str.replace(/,/g, ""));
  };

  const maxDiscount = useMemo(() => {
    const rpToBaht = _.floor(myRp / rpConvertRate); // หารหายอดตั้งต้นแบบไม่เอาเศษ - ยอดที่ลดได้สูงสุด (บาท)
    const totalDelivery = delivery - deliveryDiscount;
    return rpToBaht >= totalDelivery ? totalDelivery : rpToBaht; // THB
  }, [deliveryDiscount, myRp,delivery]);

  const maxRp = useMemo(() => {
    return maxDiscount * rpConvertRate;
  }, [deliveryDiscount, myRp,delivery]);

  const useDiscount = useMemo(() => {
    props.setBillValue({
      discount_redeem: _.floor(formatToNumber(inputRp) / rpConvertRate),
    });
    return _.floor(formatToNumber(inputRp) / rpConvertRate); // :: ยอดที่ลดได้จริง (บาท)
  }, [inputRp, rpConvertRate]);

  useMemo(() => {
    if (deliveryDiscount != 0 && inputRp != 0) {
      let defaultInput = 0;
      if (myRp >= maxRp) {
        if (maxRp >= inputRp) {
          defaultInput = inputRp;
        } else {
          defaultInput = maxRp;
        }
      } else {
        defaultInput = myRp;
      }
      // myRp >= maxRp ? maxRp : myRp;
      console.log(defaultInput, useDiscount);
      setInputRp(formatToString(defaultInput));
    }
    else if(deliveryDiscount == 0 && delivery == 0){
      setInputRp(formatToString(0));
    }
  }, [deliveryDiscount,delivery]);

  useMemo(() => {
    setInputRp(formatToString(discountRedeem * rpConvertRate));
  }, [order]);
  // useEffect(() => {
  //   if (!!myRp) {
  //     const defaultInput = myRp >= maxRp ? maxRp : myRp;
  //     setInputRp(formatToString(defaultInput));
  //   }
  // }, [myRp, maxRp]);

  const onLoadRpConvertRate = async () => {
    try {
      setIsLoading(true);
      const { data } = await axios.get(
        `${URL_API}/pos/master/rp/delivery-rate`
      );
      const rate = _.toNumber(data?.data?.rate || 27);
      setRpConvertRate(rate);
      setIsLoading(false);
    } catch (error) {
      message.error(error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    onLoadRpConvertRate();
  }, []);
  const checkFormat = (val) => {
    val = val ?? 0;
    const numberRic = val?.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    if (Number.isInteger(val)) {
      return numeral(numberRic).format();
    } else {
      return numeral(numberRic).format("0,0.0[0]");
    }
  };
  return (
    <>
      <div className="bg-white" style={{ padding: "10px" }}>
        <Row
          style={{
            marginBottom: "12px",
            fontWeight: "400",
            fontSize: "16px",
          }}
        >
          <Col>
            <Typography.Text
              className="text-dark"
              style={{ marginRight: "10px" }}
            >
              คะแนน RP พร้อมใช้ปัจจุบัน :
            </Typography.Text>
            <Typography.Text style={{ color: "#F59E0B" }}>
              {checkFormat(myRp || 0)}
            </Typography.Text>
          </Col>
        </Row>
        <Row>
          <Col
            span={6}
            style={{
              height: "67px",
              border: "1px solid #F59E0B",
              color: "#F59E0B",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "600",
              fontSize: "16px",
              marginRight: "18px",
            }}
          >
            <input
              min={0}
              placeholder="0"
              className="text-center"
              style={{
                fontWeight: "600",
                border: "none",
                color: "#F59E0B",
                width: "95%",
              }}
              value={inputRp || "0"}
              disabled={isLoading || maxRp === 0}
              onBlur={() => {
                const useRealRp = useDiscount * rpConvertRate; // ยอด RP จริงที่ใช้ - ส่วนลดที่เป็น THB (ไม่เอาเศษ) * rpConvertRate
                setInputRp(formatToString(useRealRp));
              }}
              onChange={(e) => {
                let value = e.target.value; // string with comma
                const intValue = formatToNumber(value);
                if (intValue >= maxRp) {
                  value = formatToString(maxRp);
                }
                if (intValue <= 0 || isNaN(intValue)) {
                  value = formatToString(0);
                }
                const onlyNums = value.replace(/\D/g, "");
                const formatted = formatToString(onlyNums);
                setInputRp(formatted);
              }}
            />
            <span>RP</span>
          </Col>
          <Col
            style={{
              fontWeight: "400",
              height: "67px",
              fontSize: "14px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <span> 27 RP = 1 บาท </span>
            <span>
              {" "}
              ใช้ {maxRp} แลกส่วนลดค่าจัดส่งได้ ฿
              {numeral(maxDiscount).format("0,0")}
            </span>
          </Col>
        </Row>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    orders: { itemByKey, itemKeys, activeKey },
    orders,
  } = state.pos.operation;
  const order = itemByKey[activeKey];
  const summary_list = _.find(
    getSummaryTotalPayment(orders)?.summary_list,
    (order) => order.key === activeKey
  );
  return {
    myRp: order?.rp_topup || 0,
    deliveryDiscount: summary_list?.delivery_discount_total || 0,
    delivery: summary_list?.delivery || 0,
    useDiscount: order?.discount_redeem || 0,
    order: summary_list?.key,
    discountRedeem: summary_list?.discount_redeem || 0,
  };
};
export default connect(mapStateToProps, {
  setBillValue: Creators.setBillValue,
})(RpRedeem);
